import axios from "axios";
import { loaderDecrement, loaderIncrement } from "./globalLoader";

const API_BASE_URL = process.env.REACT_APP_API_URL;


export async function api(action, body = {}, { silent = false } = {}) {
  const token = localStorage.getItem("token");
  let didIncrement = false;
  try {
    if (!silent) {
      loaderIncrement();
      didIncrement = true;
    }
    const response = await axios.post(
      `${API_BASE_URL}`,
      { action, userid: localStorage.getItem("userid"), ...body },
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    const data = response?.data;
    if (data?.status !== "success") {
      throw new Error(data?.message || "Request failed");
    }
    return data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || error?.message || "Something went wrong"
    );
  } finally {
    if (didIncrement) loaderDecrement();
  }
}

export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Could not load Razorpay. Check your connection."));
    document.body.appendChild(s);
  });
}

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2
  }).format(Number(n) || 0);

export function monthLabel(m) {
  if (!m || !m.includes("-")) return m || "";
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleString("en-IN", {
    month: "long",
    year: "numeric"
  });
}

export const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })
    : "-";